module.exports = __webpack_public_path__ + "img/job.176b578e.svg";